import { Injectable, EventEmitter } from '@angular/core';
import { Observable } from 'rxjs/Rx';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';

import { ApiService } from './api.service';
import { ArticlesService } from './articles.service';
import { ContextService } from './context.service';
import { User, Panier, LignePanier } from '../models';

@Injectable()
export class CartService {


 cartevent: EventEmitter<any> = new EventEmitter();

  constructor(
  	private apiService: ApiService,
    private articleService: ArticlesService,
    private contextService: ContextService,
  ) { }

  context: string = this.contextService.getContext();

  getUserCart(): Observable<any>{
    return this.apiService.get('/panier/utilisateur')
      .map(data => {
          console.log(data)
          if(data.montantTotal == NaN){
            let total: number = 0;
            data.articles.forEach(function (e){
              total += e.quantite * e.prixUnitaireTTC;
              // let temp: any;
              // this.articleService.get(e.codeEAN,this.context ).subscribe(
              //   dat => temp = dat,
              //   error => console.log(error),
              //   () => {
              //     if(temp.article.dateDisponibiliteReelle != null){
              //       e.dateDisponibilite = '';
              //     } else {
              //       e.dateDisponibilite = temp.article.dateDisponibiliteTheorique;
              //     }
              //   }
              // );
            }, this);
            total += data.montantFraisDePort;
            data.montantTotal = total;
          }
          
          // // console.log(result)
          this.setLocalCart(data)
          return data;
        }
      );
  }

  postLineValidate(ligne: any): Observable<Panier>{
    return this.apiService.post('/panier/ligne/validation', ligne)
      .map(data => {
          // console.log(data)
          let temp = data;
          
          if(data._body.includes('<br />')){
            temp._body = data._body.split('<br />')[0];
          }
          return temp.json();
        }
      );
  }

  postLineValidateSave(ligne: any): Observable<Panier>{
    return this.apiService.post('/panier/ligne', ligne)
      .map(data => {
        console.log(data)
          let temp = data;
          if(data._body.includes('<br />')){
            temp._body = data._body.split('<br />')[0];
          }
          return temp.json();
        }
      );
  }

  putLineUpdate(ligne: any): Observable<Panier>{
    return this.apiService.put('/panier/ligne', ligne)
      .map(data => data);
  }

  deleteLine(id: number): Observable<Panier>{
    return this.apiService.delete('/panier/ligne/' + id)
      .map(data => data);
  }



  deleteCart(): Observable<any>{
    return this.apiService.delete('/panier')
      .map(data => {
        return data;
      });
  }


  getLocalCart(): Panier{
    let cart = JSON.parse(sessionStorage.getItem('local_cart_hachette_kne'));
    let result: any = cart;
    if(cart == null) return null;
    if(!cart.lignePanier){
      sessionStorage.removeItem('local_cart_hachette_kne');
      return null;
    }
    result.total = 0;
    console.log(result)
    cart.lignePanier.forEach(function (e){
      result.total += e.quantite * e.prixUnitaireTTC;
      // let temp: any;
      this.articleService.get(e.codeEAN, this.context).subscribe(
        dat => {
          if(dat.article.dateDisponibiliteReelle != null){
            e.dateDisponibilite = '';
          } else {
            e.dateDisponibilite = dat.article.dateDisponibiliteTheorique;
          }
        },
        error => console.log(error)
        // () => {
        //   if(temp.article.dateDisponibiliteReelle != null){
        //     e.dateDisponibilite = '';
        //   } else {
        //     e.dateDisponibilite = temp.article.dateDisponibiliteTheorique;
        //   }
        // }
      );
    }, this);
    return result;
  }

  isEmptyLocalCart(): boolean{
    if(sessionStorage.getItem('local_cart_hachette_kne') === null){
      return true;
    } else {
      return false;
    }
  }

  setLocalCart(body: any){
    if(body.lignePanier){
      body.lignePanier.sort( function(a, b){
        return a.libelleArticle > b.libelleArticle;
      });

      if(body.lignePanier.length == 0){
        body.montantTotal = body.montantTotalHT = body.montantFraisDePort = 0;
      }

      sessionStorage.setItem('local_cart_hachette_kne', JSON.stringify(body));
    }
  }

  addLineToLocalCart(ligne: LignePanier, fraisDP: number){
    this.context = this.contextService.getContext();
    let cart: Panier = this.getLocalCart();
    if(cart.lignePanier){
      let sameOffre = cart.lignePanier.filter(cl => cl.idOffreCommerciale == ligne.idOffreCommerciale && cl.indicateurAdoption == ligne.indicateurAdoption);

      let sameReference = cart.lignePanier.filter(cl => cl.referenceLPC == ligne.referenceLPC);

       cart.montantFraisDePort = (cart.montantFraisDePort >= fraisDP) ? cart.montantFraisDePort : fraisDP;
      if(sameOffre.length == 0){
       
        cart.montantTotal += ligne.montantTotal;
        cart.montantTotalHT += ligne.montantTotal - (ligne.montantTotal * (ligne.tauxDeTaxe / 100));
        if(!sameReference) cart.montantFraisDePort += fraisDP;
        cart.lignePanier.push(ligne);
      } else {
        // console.log(this.context)
        if(this.context != 'B2C'){
          cart.lignePanier.forEach( function(cl){
            if(cl.idOffreCommerciale == ligne.idOffreCommerciale && cl.indicateurAdoption == ligne.indicateurAdoption){
              cl.quantite += ligne.quantite;
            }
          });
        }
      }
    }
    //console.log(cart)
    this.setLocalCart(cart);
  }

  updateLineFromLocalCart(li: LignePanier){
    this.context = this.contextService.getContext();
    let cart: Panier = this.getLocalCart();
    // console.log(cart);
    let ligne = cart.lignePanier.filter( l => (l.id == li.id && l.idOffreCommerciale == li.idOffreCommerciale && l.indicateurAdoption == li.indicateurAdoption) );
    cart.montantTotal -= li.montantTotal;
    cart.montantTotalHT -= li.montantTotal - (li.montantTotal * (li.tauxDeTaxe / 100));
    ligne[0].quantite = li.quantite;
    
    let temp: any = {};
    temp.marche = this.context;
    temp.idOffreCommerciale = ligne[0].idOffreCommerciale;
    temp.indicateurAdoption = ligne[0].indicateurAdoption;
    temp.quantite = ligne[0].quantite;
    // temp.idPaysLPC = ()
    let value: any;
    this.postLineValidate(temp)
      .subscribe(
        data => value = data,
        errors => console.log(errors),
        () => {
          cart.montantTotal += value.montantTotal;
          cart.montantTotalHT += value.montantTotalHT;

          ligne[0] = value.lignePanier[0];

          cart.lignePanier = cart.lignePanier.filter( l => (l.id != li.id || l.idOffreCommerciale != li.idOffreCommerciale || (l.idOffreCommerciale == li.idOffreCommerciale && l.indicateurAdoption != li.indicateurAdoption)) );
          cart.lignePanier.push(ligne[0]);
          this.setLocalCart(cart);
        }
      );

  }

  deleteLineFromLocalCart(li: LignePanier){
    let cart: Panier = this.getLocalCart();
    cart.lignePanier = cart.lignePanier.filter( l => (l.id != li.id || l.idOffreCommerciale != li.idOffreCommerciale || (l.idOffreCommerciale == li.idOffreCommerciale && l.indicateurAdoption != li.indicateurAdoption)) );
    let ligne = li;

    // console.log(cart)

    if(cart.lignePanier && cart.lignePanier.length != 0){
      let temp: any = {};
      temp.marche = this.context;
      temp.idOffreCommerciale = ligne.idOffreCommerciale;
      temp.indicateurAdoption = ligne.indicateurAdoption;
      temp.quantite = ligne.quantite;
      let value: any;

      this.postLineValidate(temp)
        .subscribe(
          data => {
            value = data
          },
          error => console.log(error),
          () => {
            
             
            if(value.montantFraisDePort && (value.montantFraisDePort > cart.montantFraisDePort)  ){
              cart.montantFraisDePort = value.montantFraisDePort;
            }
            if(value.montantTotal){
              cart.montantTotal -= value.montantTotal;
            }
            if(value.montantTotalHT){
              cart.montantTotalHT -= value.montantTotalHT;
            }

            this.setLocalCart(cart);
            this.cartevent.emit('cartchange');
          }
        );

    } else {
      // console.log(cart)
      this.setLocalCart(cart);
      this.cartevent.emit('cartchange');
    }

   
  }

  destroyLocalCart(){
    sessionStorage.removeItem('local_cart_hachette_kne');
  }

  destroyCart(){

    this.getUserCart().subscribe(
      data => {
        if(data.lignePanier){
          data.lignePanier.forEach( function(l) {
            this.deleteLine(l.id).subscribe(
               data => {
                  this.cartevent.emit('cartchange');
                }
             );
          }, this);
          
        }
      },
      error => {
        //console.log(error);
      }
    );
  }

  hasLinesLocalCart(): boolean{
    let cart: Panier = this.getLocalCart();
    if(cart.lignePanier){
      if(cart.lignePanier.length > 0){
        return true;
      } else {
        return false;
      }
    } else {
      return false;
    }
  }

/*  postLine(line){
     this.
  }*/

  convertLocaltoCart(authed: boolean, idPaysLPC:number){

    if(authed){
     let localCart = this.getLocalCart();
   
         let vm=this;
         if(localCart && localCart.lignePanier){
           localCart.lignePanier.forEach( function(item){
              
               let body:any = {
                idOffreCommerciale: item.idOffreCommerciale,
                quantite: item.quantite,
                idPaysLPC:idPaysLPC,
                indicateurAdoption:item.indicateurAdoption
              };
              // console.log(body)
            
               this.postLineValidateSave(body).subscribe(

                 data=>{
                  this.setLocalCart(data)
                   this.cartevent.emit('cartchange');
                 }

                )
            }, this);

            // this.destroyLocalCart();
            
  
      }
    }  
  }



 upLoadFile(formdata: any): Observable<any>{
  console.log(formdata);
    return this.apiService.postfile('/upload/preuveAchat', formdata)
      .map(data => {
          return data['preuve-achat']
        }, 
        err=>{
           err
        }
      );
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/services/cart.service.ts